module.exports = __webpack_public_path__ + "img/simbolo-pb.700216ce.svg";